<div class="page-content-wrapper">
  <app-sidebar-layout [showMenuToggle]="true">
    <div class="filter-forms-nav pages-title-nav p-0">
      <div class="container-fluid px-4">
        <div class="row align-items-center">
          <div class="sample-details-title col-xs-12 col-sm-12 col-md-12 col-12 nav-colmn pl-0 ">
            <div class="page-name-div sample-name-list d-flex align-items-center">
              <a class="left-arrow" routerLink="/dashboard/integrations/lab-integrations">
                <span class="material-symbols-outlined purple-text pt-1 ">chevron_left</span>
              </a>
              <span>
                {{ (labData?.labIntegrationType === integrationTypeEnum.GalsonLab ? 'Galson Lab' :
                labData?.labIntegrationType === integrationTypeEnum.Lims ? 'Lims Lab' :
                labData?.labIntegrationType === integrationTypeEnum.AlsLab ? 'ALS Lab' : '') | translate }}
              </span>
              <span> : {{ labData?.labName}} </span>
              <span class="ml-auto" *objectHasPermission="permissionObject; action: editAction"> <i class="edit-icon material-icons material-grey-icon"
              (click)="openLabIntegrationDialog()">edit</i> </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="page-content-inner-wrap card-style-sec lab-integration-details-page-wrap custom-scrollbar">
      <div class="container-fluid">
        <div class="row pt-2">
          <div class="col-md-8 px-0">
            <div class="col-md-12 card-col">
              <ng-container
              *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/sidenav/new_reports.svg', title: 'Report To', fields: reportFields }"></ng-container>
            </div>
            <div class="col-md-12 card-col">
              <ng-container
              *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/sidenav/new_reports.svg', title: 'Invoice To', fields: invoiceFields }"></ng-container>
            </div>
            <div class="col-md-12 card-col">
              <ng-container
              *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/sidenav/new_reports.svg', title: 'Lab Address', fields: labFields }"></ng-container>
            </div>
            <div class="col-md-12 card-col">
              <ng-container
              *ngTemplateOutlet="displaySection; context: { imageSrc: 'assets/sidenav/new_reports.svg', title: 'Settings', fields: settingsFields }"></ng-container>
            </div>
            <div class="col-md-12 card-col">
              <h3 class="section-title">
                <span class="material-symbols-outlined section-grid-icon">view_column</span>
                {{ 'Sample Grid Columns' | translate }}
              </h3>
              <div class="section sample-grid-config">
                <p class="config-description">{{ 'Configure which columns appear in the Chain of Custody sample table for this lab.' | translate }}</p>

                @if (isLoadingGridConfig) {
                  <div class="loading-spinner">
                    <mat-spinner diameter="24"></mat-spinner>
                  </div>
                }

                @if (!isLoadingGridConfig) {
                  <div class="columns-list">
                    @for (column of sampleColumns; track trackByIndex($index)) {
                      <div class="column-item">
                        <mat-checkbox
                          [checked]="column.visible"
                          (change)="toggleColumnVisibility(column)"
                          color="primary">
                          {{ column.displayName | translate }}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                }

                <div class="save-button-container">
                  <button
                    class="btn btn-primary"
                    (click)="saveGridViewConfig()"
                    [disabled]="isSavingGridView || isLoadingGridConfig">
                    @if (isSavingGridView) {
                      <mat-spinner diameter="18" class="button-spinner"></mat-spinner>
                    }
                    @if (!isSavingGridView) {
                      <span>{{ 'Save Configuration' | translate }}</span>
                    }
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 px-0">
            <h3 class="section-title">
              <img src="assets/images/sample-overview.svg" class="mr-1">
              {{ 'TAT' | translate}}
            </h3>
            <div class="tableColStyle custom-theme-table px-1 pt-0">
              <div class="custom-scrollbar sticky-header table-shadow h-auto">
                <table mat-table [dataSource]="$safeNavigationMigration(labData?.tats)" class="h-100 table table-striped">
                  <ng-container matColumnDef="turnAroundTime">
                    <th mat-header-cell *matHeaderCellDef class="left-aligned">
                    {{'Turn Around Time' | translate}}</th>
                    <td mat-cell *matCellDef="let element" class="left-aligned pl-20">
                    {{ element.turnAroundTime }} </td>
                  </ng-container>
                  <ng-container matColumnDef="surcharge">
                    <th mat-header-cell *matHeaderCellDef>{{'Surcharge' | translate}}</th>
                    <td mat-cell *matCellDef="let element">{{ element.surcharge }}</td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="tatColumns"></tr>
                  <tr mat-row *matRowDef="let row; let even = even; columns: tatColumns;"
                  [class.even-row]="even"> </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </app-sidebar-layout>
</div>

<ng-template #displaySection let-imageSrc="imageSrc" let-title="title" let-fields="fields">
  <h3 class="section-title">
    <img [src]="imageSrc" class="mr-1">
    {{ title | translate}}
  </h3>
  <div class="section">
    <div class="field-container">
      @for (field of fields; track trackByIndex($index)) {
        <div class="field">
          <div class="field-label">{{ field.label | translate}}</div>
          <div class="field-value" [class.field-with-copy]="field.isCopyable">
            {{ field.value || '-' }}
            @if (field.isCopyable) {
              <span class="material-icons copy-icon"
                (click)="copyToClipboard(field.value)"
              [title]="'Copy to clipboard' | translate">content_copy</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>